'use client';

import { useTracker } from '@lichtblick/tracker';
import { usePathname } from 'next/navigation';
import { type FC, useEffect } from 'react';

export const Tracking: FC = () => {
  const virtPagePath = usePathname();
  const { trackPageMetaEvent, trackVirtPathEvent } = useTracker();

  useEffect(() => {
    trackVirtPathEvent({ virtPagePath, virtPageTitle: document.title });
    trackPageMetaEvent({ pageArea: 'B2B', pageType: 'checkout' });
  }, [trackPageMetaEvent, trackVirtPathEvent, virtPagePath]);

  return null;
};
